import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { InstagramIcon, TwitterIcon, PhoneCallIcon, EnvelopeTwoIcon } from "assets/icons";
import { FacebookIcon, LinkedInIcon } from "assets/website";
import { ContactForm } from "./contactForm";

const ContactUs = () => {
  const [searchParams] = useSearchParams();
  const isSalesInquiry =
    searchParams.get("subject")?.includes("credits") ||
    searchParams.get("message")?.includes("credits");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#EFF4FA]">
      <div className="w-[90%] mx-auto mt-20">
        {/* Hero */}
        <section className="relative py-16 sm:py-24 overflow-hidden">
          <h1 className="text-4xl sm:text-6xl font-bold text-[#00003F] text-center">
            {isSalesInquiry ? "Talk to Sales." : "Contact Us."}
          </h1>
        </section>

        {/* Contact Section */}
        <section className="relative pb-14 lg:mb-[400px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-10">
            {/* Left - Get in Touch */}
            <div className="shrink-0 lg:pt-[70px]">
              <h2 className="text-3xl sm:text-5xl font-semibold text-[#050B17] mb-3">
                {isSalesInquiry ? "Need a larger credit bundle?" : "Get in Touch With Us"}
              </h2>
              <p className="text-[#475467] text-base sm:text-lg lg:text-[22px] mb-8">
                {isSalesInquiry
                  ? "We’ve prefilled your message so we can help with more than 19,999 credits."
                  : "Experiencing an issue or have a question? Let us know."}
              </p>

              <div className="flex sm:flex-row flex-col gap-4 mb-6 border-b border-[#EAECF0] pb-8 sm:w-fit w-full">
                {/* Phone card */}
                <a
                  href="tel:+2348031301167"
                  className="flex items-center gap-3 bg-white border border-[#EAECF0] rounded-xl px-6 py-3 shadow-[0px_2px_1px_0px_#0000000D] hover:opacity-90 transition-opacity"
                >
                  <PhoneCallIcon className="w-5 h-5 shrink-0 [&_path]:fill-[#012169]" />
                  <div>
                    <p className="text-lg font-medium text-[#050B17]">Phone:</p>
                    <p className="text-lg text-[#344054]">+234 803 130 1167</p>
                  </div>
                </a>

                {/* Email card */}
                <a
                  href="mailto:contact@precisionmatch.ai"
                  className="flex items-center gap-3 bg-white border border-[#EAECF0] rounded-xl px-6 py-3 shadow-[0px_2px_1px_0px_#0000000D] hover:opacity-90 transition-opacity"
                >
                  <EnvelopeTwoIcon className="w-5 h-5 shrink-0 [&_path]:fill-[#012169]" />
                  <div>
                    <p className="text-lg font-medium text-[#050B17]">Email:</p>
                    <p className="text-lg text-[#344054]">
                      contact@precisionmatch.ai
                    </p>
                  </div>
                </a>
              </div>

              {/* Social icons */}
              <div className="flex gap-4 items-center">
                <a
                  href="https://www.instagram.com/precisionmatch/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-full bg-white border border-[#EAECF0] flex items-center justify-center transition-opacity hover:opacity-80"
                >
                  <InstagramIcon className="w-5 h-5 [&_path]:fill-[#C16009]" />
                </a>
                <a
                  href="https://x.com/precisionmatch"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-full bg-white border border-[#EAECF0] flex items-center justify-center transition-opacity hover:opacity-80"
                >
                  <TwitterIcon className="w-5 h-5 [&_path]:fill-[#050B17]" />
                </a>
                <a
                  href="https://www.facebook.com/share/18MgqCRfxZ/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-full bg-white border border-[#EAECF0] flex items-center justify-center transition-opacity hover:opacity-80"
                >
                  <FacebookIcon className="w-5 h-5 text-[#0A71E7]" />
                </a>
                <a
                  href="https://ng.linkedin.com/company/precision-match"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-full bg-white border border-[#EAECF0] flex items-center justify-center transition-opacity hover:opacity-80"
                >
                  <LinkedInIcon className="w-5 h-5 text-[#0A0AA2]" />
                </a>
              </div>
            </div>

            {/* Right - Form (protruding below section). Stays above the section
                it overhangs, but below the fixed navbar (z-[99]) — matching it
                let the card paint over the header on scroll. */}
            <div className="relative lg:mb-[-400px] z-10">
              <div className="bg-white border border-[#E4E7EC] rounded-2xl p-6 sm:p-8 lg:p-12 shadow-[0px_20px_40px_0px_#5281EC33,20px_0px_40px_0px_#5281EC33]">
                <ContactForm title={isSalesInquiry ? "Talk to Sales" : "Leave your message"} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export { ContactUs };
